import img1 from '../assets/favorite-default-1.webp';
import img2 from '../assets/favorite-default-2.webp';
import img3 from '../assets/favorite-default-3.webp';
import img4 from '../assets/favorite-default-4.webp';
import img5 from '../assets/favorite-default-5.webp';
import img6 from '../assets/favorite-default-6.webp';
import img7 from '../assets/favorite-default-7.webp';

export const favoriteDefaultImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7
];
export const MAX_OF_LISTINGS_IN_ONE_LIST = 10;
export const MAX_OF_FAVORITES_LIST_OF_A_USER = 10;
